module.exports = __webpack_public_path__ + "img/xm.20313299.png";